import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface QuestionMarkIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const QuestionMarkIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick
}: QuestionMarkIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            onClick={onClick}
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.883 4.338C7.883 4.698 7.736 5.073 7.442 5.463L6.776 6.345C6.668 6.489 6.614 6.642 6.614 6.804V6.993H5.444V6.723C5.444 6.393 5.558 6.081 5.786 5.787L6.452 4.932C6.626 4.71 6.713 4.509 6.713 4.329C6.713 4.113 6.647 3.936 6.515 3.798C6.383 3.66 6.206 3.591 5.984 3.591C5.756 3.591 5.579 3.663 5.453 3.807C5.327 3.945 5.264 4.122 5.264 4.338H4.094C4.094 3.792 4.28 3.351 4.652 3.015C5 2.697 5.444 2.538 5.984 2.538C6.518 2.538 6.962 2.694 7.316 3.006C7.694 3.342 7.883 3.786 7.883 4.338ZM6.65 9H5.408V7.803H6.65V9Z"
                fill={color}
            />
        </svg>
    )
}

export default QuestionMarkIcon;